import gql from 'graphql-tag';

const GET_IMPORT_ASSET_SCRIPT = gql`
  query($classId: ID!) {
    getImportAssetScript(classId: $classId) {
      language
      content
      scriptVariables {
        runTime {
          name
        }
        placeHolders {
          name
          labelName
        }
      }
    }
  }
`;
const GET_USERS_ADD_ONS = gql`
  query($addOnIds: [ID]) {
    getAddOnStatusForLoggedInUser(addOnIds: $addOnIds) {
      addOnId
      addOn
      enabled
    }
  }
`;
export { GET_IMPORT_ASSET_SCRIPT, GET_USERS_ADD_ONS };
